@if (showSpinner) {
  <app-loader> </app-loader>
}

<div class="counts-main-wrapper">
   @if (isLoading) {
      <div class="skeleton skeleton-card"></div>
    } @else {
      <div class="comon-counts">
          <div class="comon-count-head">
            <div class="comon-head-left">
              <div class="comon-head-icon">
                <img src="../../../../assets/theme1/time.svg" alt="icon missing">
              </div>
              <div class="comon-head-body">
                <p>
                  <span>Today</span>
                  Attendance
                </p>
              </div>
            </div>
            @if(actionView){
              <div class="comon-head-navigation"  role="button" [routerLink]="['/attendance-management']">
              
                <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 7H17M17 7L11 1M17 7L11 13" stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>

            </div>
            }
            
          </div>
          <div class="comon-count-body mt-2">
            <div class="comon-head-left attendance-section">
              <div class="comon-circle pounch-in">

              </div>
              <div class="comon-head-body">
                <p>
                  <span>Punch In</span>
                  {{ formatTime(todayAttendance?.check_in) }}
                </p>
              </div>
            </div>
            <div class="comon-head-left attendance-section">
              <div class="comon-circle duration">

              </div>
              <div class="comon-head-body">
                <p>
                  <span>Duration</span>
                  {{ todayAttendance?.total_hours ? todayAttendance?.total_hours + ' hrs' : '0 hrs' }}
                </p>
              </div>
            </div>
            <div class="comon-head-left attendance-section mt-2">
              <div class="comon-circle pounch-out">

              </div>
              <div class="comon-head-body">
                <p>
                  <span>Punch Out</span>
                  {{ formatTime(todayAttendance?.check_out) }}
                </p>
              </div>
            </div>

            <div class="comon-head-left attendance-section mt-2">
              <div class="comon-head-body status">
                <p [ngClass]="{
                            'short-hours': isShortHours,
                            'full-hours': isFullDay,
                            'absent': isAbsent
                          }">
                  {{ attendanceStatus }}
                </p>
              </div>
            </div>
          </div>
        </div>
    
    }
  
     @if (isLoading) {
      <div class="skeleton skeleton-card"></div>
    } @else {
      <div class="comon-counts ">
        <div class="comon-count-head">
          <div class="comon-head-left">
            <div class="comon-head-icon">
              <img src="../../../../assets/theme1/calendar.svg" alt="icon missing">
            </div>
            <div class="comon-head-body">
              <p>
                <span>Today</span>
                Leaves
              </p>
            </div>
          </div>
           @if(actionView){
             <div class="comon-head-navigation" role="button" [routerLink]="['/show-leaves']">
               <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 7H17M17 7L11 1M17 7L11 13" stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
             </div>
           }
        </div>
        <div class="comon-count-body mt-2">
          <div class="leave-body-left">
            <p>
              <span>{{this.totalPaidLeaves | number:'1.0-2'}}</span>
              paid leaves
            </p>
          </div>
          <div class="leave-body-right">
            <p>
              <span>{{availablePaidLeaves | number:'1.0-2'}}</span>
              available leaves
            </p>
            <p>
              <span>{{availedPaidLeaves | number:'1.0-2'}}</span>
              availed leaves
            </p>
          </div>

        </div>
      </div>
    }

      @if (isLoading) {
      <div class="skeleton skeleton-card"></div>
    } @else {
 <div class="comon-counts ">
    <div class="comon-count-head">
      <div class="comon-head-left">
        <div class="comon-head-icon">
          <img src="../../../../assets/theme1/evaluation.svg" alt="icon missing">
        </div>
        <div class="comon-head-body">
          <p>
            <span>This {{evalutaionMonth}}</span>
            Evaluation
          </p>
        </div>
      </div>
       @if(actionView){
        <div class="comon-head-navigation" role="button" [routerLink]="['/evaluation-list']">
          <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 7H17M17 7L11 1M17 7L11 13" stroke="#2D2D2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
       }
      
    </div>
    <div class="comon-count-body mt-2">
      <div class="evalution-sect">
        <p>
          <span>{{latestevaluation}}</span>
          out of {{total_evalutaion}}
        </p>
        <div class="progress-evalutaion">
          @if(evaluationStatus === 'Increased'){
          <img src="../../../../assets/theme1/increase.svg" alt="increase icon">
          }
          @if(evaluationStatus === 'Decreased'){
          <img src="../../../../assets/theme1/decrease.svg" alt="decrease icon">
          }
          @if(evaluationStatus === 'No Change'){
          <span>No change</span>
          }
          <h1>
            <span [ngClass]="{
                'text-green': evaluationStatus === 'Increased',
                'text-red': evaluationStatus === 'Decreased'
              }">{{percentageEvaluation}}</span>
            <p>than prv month</p>
          </h1>
        </div>
      </div>
    </div>
  </div>
    }
 

    
  <div class="attendance-cart-main pb-0" [ngClass]="{ 'no-padding': isLoading }">
    @if (isLoading) {
      <div class="skeleton skeleton-attendance"></div>
    } @else {
    <div class="attendance-cart-heading">
      <h1>Attendance Summary <span>(This month)</span></h1>
      <div class="navigate-arrow" role="button" [routerLink]="['/attendance-management']">
        <img src="../../../../assets/theme1/arrow-right.svg">
      </div>
    </div>

    <div class="chart-legend">
      <div class="common-legend">
        <span class="legend-color all-good"></span>
        <span>All good</span>
      </div>
      <div class="common-legend">
        <span class="legend-color overtime"></span>
        <span>Over time</span>
      </div>
      <div class="common-legend">
        <span class="legend-color short-time"></span>
        <span>Short time</span>
      </div>
    </div>
    <div id="chart">
      <apx-chart #chart [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
        [yaxis]="chartOptions.yaxis" [plotOptions]="chartOptions.plotOptions" [dataLabels]="chartOptions.dataLabels"
        [stroke]="chartOptions.stroke" [fill]="chartOptions.fill" [tooltip]="chartOptions.tooltip"
        [legend]="chartOptions.legend" [grid]="chartOptions.grid">
      </apx-chart>
    </div>
  }
  </div>

  
    <div class="shift-detail-section" [ngClass]="{ 'no-padding': isLoading }">
        @if (isLoading) {
        <div class="skeleton skeleton-shift"></div>
      } @else {
      <div class="attendance-cart-heading">
        <h1>Shift Details</h1>
        <!-- <div class="navigate-arrow">
          <img src="../../../../assets/theme1/arrow-right.svg">
        </div> -->
      </div>
      <div class="portal-punch-section">
        <h1>Portal punch in<span>{{userData?.attandance_type}}</span></h1>
      </div>
      <div class="portal-shifttime">
        <div class="shift-time-inner mt-4">
          @for (shift of userData?.usershittime; track shift.id; let i = $index) {
          <div class="comon-shift-main" [ngClass]="{
          'last-comon-shift': i === (userData?.usershittime?.length - 1),
          'off-day': shift.off_day === '1'
        }">
            <div class="common-shift-image">
              <img [src]="shift.off_day === '1' 
                          ? '../../../../assets/theme1/off-day.png' 
                          : '../../../../assets/theme1/clock.png'" alt="Shift Icon" />
            </div>

            <div class="comon-shift-detail">
              <h1>{{ shift.day }}</h1>
              @if(shift.off_day === '0'){
              <p>
                {{ formatTime(shift.start_time) }} to {{ formatTime(shift.end_time) }}
              </p>
              }
              @else{
              <p class="text-muted">Off Day</p>

              }

            </div>
          </div>
          }
        </div>
      </div>
    }
    </div>

    
          <div class="upcoming-payroll-section" [ngClass]="{ 'no-padding': isLoading }">
      @if (isLoading) {
        <div class="skeleton skeleton-attendance"></div>
      } @else {
            <div class="attendance-cart-heading">
              <h1>Upcoming Payroll</h1>
              <!-- <div class="navigate-arrow">
                <img src="../../../../assets/theme1/arrow-right.svg" alt="missing icon">
              </div> -->
            </div>
            <div class="payroll-mian-head mt-4">
              <div class="total-salary-section">
                <div class="slary-comon-img">
                  <img src="../../../../assets/theme1/goss-salary.png" alt="missing icon">
                </div>
                <div class="comon-salary-heading">
                  <p>Total Gross Salary</p>
                  <h1>{{ userSalary?.total_salary | number:'1.2-2'}}<span>/-PKR</span></h1>
                </div>
              </div>
              <div class="total-salary-section">
                <div class="slary-comon-img">
                  <img src="../../../../assets/theme1/total-salary.png" alt="missing icon">
                </div>
                <div class="comon-salary-heading">
                  <p>Accumulated Salary</p>
                  <h1>{{ (userSalary?.earned_salary - userSalary?.deductions?.total_deduction) | number:'1.2-2'
                    }}<span>/-PKR</span></h1>
                </div>
              </div>
              <div class="total-deduction-section">
                <div class="slary-comon-img">
                  <img src="../../../../assets/theme1/total-deduction.png" alt="missing icon">
                </div>
                <div class="comon-salary-heading">
                  <p>Total Deduction</p>
                  <h1>{{(userSalary?.deductions?.total_deduction) | number:'1.2-2'}}<span>/-PKR</span></h1>
                </div>
              </div>
            </div>
            <div class="total-salary-details mt-4">
              <div class="total-salary-comon">
                <div class="comon-salary-heading">
                  <p>
                    Other Dedcutions
                    <svg data-toggle="modal" data-target="#deductionEditModal" width="16" height="16" viewBox="0 0 16 16"
                      fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.9987 10.6673V8.00065M7.9987 5.33398H8.00536M14.6654 8.00065C14.6654 11.6826 11.6806 14.6673 7.9987 14.6673C4.3168 14.6673 1.33203 11.6826 1.33203 8.00065C1.33203 4.31875 4.3168 1.33398 7.9987 1.33398C11.6806 1.33398 14.6654 4.31875 14.6654 8.00065Z"
                        stroke="#555555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </p>
                  <h1>{{userSalary?.deductions?.absent_days}}<span>{{userSalary?.deductions?.absent_deduction |
                      number:'1.2-2'}}/-PKR</span></h1>
                </div>
              </div>
              <div class="total-salary-comon">
                <div class="comon-salary-heading">
                  <p>Over Time</p>
                  <h1>
                    {{userSalary?.overtime?.hours}}<span>{{userSalary?.overtime?.amount | number:'1.2-2'}}/-PKR</span>
                  </h1>
                </div>
              </div>
              <div class="total-salary-comon">
                <div class="comon-salary-heading">
                  <p>Loan Amount</p>
                  <h1>{{userSalary?.deductions?.loan_deduction | number:'1.2-2'}}<span>/-PKR</span>
                  </h1>
                </div>
              </div>
              <div class="total-salary-comon last-total-salary">
                <div class="comon-salary-heading">
                  <p>Advance Amount</p>
                  <h1>{{(userSalary?.deductions?.advance_payment ?? 0) | number:'1.2-2'}}<span>/-PKR</span></h1>
                </div>
              </div>

              <div class="account-main-section mt-3">
                <div class="account-main-head">
                  <div class="account-img">
                    <img src="../../../../assets/theme1/mezan-bank.png" alt="">
                  </div>
                  <div class="comon-salary-heading">
                    <p>Bank Details</p>
                    <h1>Meezan Bank</h1>
                  </div>
                </div>
                <div class="account-detail-body mt-3">
                  <p>Account number:</p>
                  <h1>{{userData?.ac_number}}</h1>
                </div>

              </div>
            </div>
          }
          </div>

          <div class="shift-detail-section employee-card-main" [ngClass]="{ 'no-padding': isLoading }">
          @if (isLoading) {
                <div class="skeleton skeleton-shift"></div>
              } @else { 
              <div class="attendance-cart-heading">
                <h1>Employee Card</h1>
              </div>
              <div class="employee-main-cards mt-3" #employeeCards>
                <div class="emloyee-card">
                  <img src="../../../../assets/theme1/employee-card.png" alt="missing card">
                  <div class="employee-card-detail">
                    <div class="company-logo mt-1">
                      <img src="../../../../assets/theme1/kodex-logo-1.png" alt="missing">
                    </div>
                    <div class="employee-image">
                      <img [src]="userData?.profile_image" alt="missing">
                    </div>
                    <div class="employee-info">
                      <h1>{{userData?.first_name}}{{userData?.last_name}}</h1>
                      <p>{{userData?.department}}</p>
                    </div>
                    <div class="employee-detail">
                      <div class="employee-detail-common">
                        <p>ID:</p>
                        <p>{{userData?.attendance_user_id}}</p>
                      </div>
                      <div class="employee-detail-common">
                        <p>Email:</p>
                        <p>{{userData?.email}}</p>
                      </div>
                      <div class="employee-detail-common">
                        <p>Phone:</p>
                        <p>{{userData?.phone_number}}</p>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="emloyee-card">
                  <img src="../../../../assets/theme1/employee-card-1.png" alt="missing card">
                  <div class="employee-card-detail back-side-card">
                    <div class="company-logo back-card-logo mt-1">
                      <img src="../../../../assets/theme1/kodex-logo-1.png" alt="missing">
                    </div>
                    <div class="qr-image">
                      <img src="../../../../assets/theme1/Qr.png" alt="missing">
                    </div>
                    <div class="employee-info">
                      <p>Kodextech@gmail.com</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="download-card mt-3" (click)="downloadPDF()">
                <img src="../../../../assets/theme1/download-icon.png" alt="missing icon">
                <p>Download</p>
              </div>

            }
          </div>

 
</div>



  <div class="modal fade" id="deductionEditModal" tabindex="-1" role="dialog" aria-labelledby="leaveinfoModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content ">
              <div class="modal-header">
                <h5 class="modal-title" id="leaveinfoModalLabel">Total Deduction Detail</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body info-modal-body">
                <div class="row">
                  <div class="col-4 p-0">
                    <div class="col-head bold-font">
                     Category 
                    </div>
                  </div>
                  <div class="col-4 p-0 bold-font">
                    <div class="col-data col-center">
                      Duration
                    </div>
                  </div>
                  <div class="col-4 p-0 bold-font">
                    <div class="col-data col-center">
                      Deduction
                    </div>
                  </div>
                    <div class="col-4 p-0">
                      <div class="col-head">
                       Check In Late
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-data col-center remaining-leave-bg">
                        <div>
                          {{userSalary?.deductions?.late_hours}}
                        </div>
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-data col-center ">
                        <div>
                          {{userSalary?.deductions?.late_deduction | number:'1.2-2'}} /-PKR
                        </div>
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-head">
                       Absents
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-data col-center remaining-leave-bg">
                        <div>
                          {{userSalary?.deductions?.absent_days }}
                        </div>
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-data col-center ">
                        <div>
                         {{userSalary?.deductions?.absent_deduction | number:'1.2-2'}}/-PKR
                        </div>
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-head">
                       Short Hours
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-data col-center remaining-leave-bg">
                        <div>
                          {{userSalary?.deductions?.short_hours}}
                        </div>
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-data col-center">
                        <div>
                          {{userSalary?.deductions?.short_hour_deduction | number:'1.2-2'}}/-PKR
                        </div>
                      </div>
                    </div>
                     <div class="col-4 p-0">
                      <div class="col-head">
                       Unpaid Leave
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-data col-center remaining-leave-bg">
                        <div>
                          {{userSalary?.deductions?.unpaid_leaves}} 
                        </div>
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-data col-center">
                        <div>
                         {{userSalary?.deductions?.unpaid_leave_deduction | number:'1.2-2'}}/-PKR
                        </div>
                      </div>
                    </div>

                </div>
              </div>

            </div>
          </div>
        </div>